var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input_video",
      staticStyle: {
        "min-height": "560px",
        height: "100%",
        "min-width": "800px",
        "padding-top": "calc(50vh - 250px)",
        "background-color": "#fff",
      },
    },
    [
      _vm.sourceVideoId
        ? _c("div", [
            _c("div", {
              staticStyle: { width: "800px", margin: "0 auto" },
              attrs: { id: "player" },
            }),
          ])
        : _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "margin-top": "100px",
                "font-size": "16px",
              },
            },
            [_vm._v(" 暂无视频 ")]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }